export default __webpack_public_path__ + "4c3c21c45cf022efc356c5ad6ed1b089.png";